module.exports = __webpack_public_path__ + "img/PY.637ed4db.png";